<template>
  <div class="h-100">
    <v-card class="bg-primary pa-5 ml-md-8 ml-2 my-8" id="title">
      <h1 id="name" class="float-right pl-3 text-accent">{{ data.intro.h1 }}</h1>
    </v-card>
    <v-card class="bg-secondary pa-5 mr-md-8 mr-2 my-8" id="intro-card">
      <h2>{{ data.intro.subtitle }}</h2>
      <p class="font">{{ data.intro.text }}</p>
    </v-card>
    <section v-for="tier in data.tiers" :key="tier.title" class="my-6">
      <v-card class="pa-5 ml-md-8 ml-2 my-4" :class="tierClass(tier)" id="tier-card">
        <h3 class="mb-1">{{ tier.title }}</h3>
        <p class="font text-medium-emphasis mb-3">{{ tier.description }}</p>
        <p class="font city-list">
          <template v-for="(city, index) in tier.cities" :key="city">
            <router-link
              v-if="getCitySlug(city)"
              :to="'/schreiner-' + getCitySlug(city)"
              class="city-link"
            >{{ city }}</router-link>
            <span v-else>{{ city }}</span>
            <span v-if="index < tier.cities.length - 1"> · </span>
          </template>
        </p>
      </v-card>
    </section>
    <v-card class="bg-secondary pa-5 mr-md-8 mr-2 my-8" id="services-card">
      <h2>Unsere Leistungen als Schreinerei in der Region</h2>
      <p class="font">
        Egal ob Sie in Reutlingen, Tübingen oder auf der Schwäbischen Alb wohnen –
        als Ihre Schreinerei vor Ort bieten wir Ihnen ein breites Leistungsspektrum:
      </p>
      <v-row class="mt-3">
        <v-col cols="12" sm="6">
          <ul class="font service-list">
            <li>Maßgefertigte Massivholzmöbel</li>
            <li>Einbauschränke und Garderoben</li>
            <li>Individuelle Küchen</li>
            <li>Schlafzimmer und Badmöbel</li>
          </ul>
        </v-col>
        <v-col cols="12" sm="6">
          <ul class="font service-list">
            <li>Kompletter Innenausbau</li>
            <li>Hotellerie und Gastronomie</li>
            <li>Ladenbau und Objektplanung</li>
            <li>Industrieklettern und Seilzugangstechnik</li>
          </ul>
        </v-col>
      </v-row>
    </v-card>
    <v-card class="bg-primary pa-5 mr-md-8 mr-2 my-8 text-center" id="cta-card">
      <h2 class="text-accent mb-3">{{ data.cta.text }}</h2>
      <div class="d-flex flex-column flex-md-row justify-center align-center">
        <v-btn
          size="large"
          class="bg-accent text-primary ma-2"
          href="tel:+4915778204841"
        >
          <v-icon start>mdi-phone</v-icon>
          +49 1577 8204841
        </v-btn>
        <v-btn
          size="large"
          class="bg-accent text-primary ma-2"
          :to="data.cta.link"
        >
          <v-icon start>mdi-email</v-icon>
          {{ data.cta.buttonText }}
        </v-btn>
      </div>
    </v-card>
  </div>
</template>

<script>
import einzugsgebietData from "../einzugsgebiet.json";
import locationData from "../locationData.json";

export default {
  name: "ServiceArea",
  setup() {
    const slugMap = {};
    locationData.forEach((loc) => {
      slugMap[loc.name] = loc.slug;
    });
    return {
      data: einzugsgebietData,
      slugMap,
    };
  },
  methods: {
    tierClass(tier) {
      const idx = this.data.tiers.indexOf(tier);
      return idx % 2 === 0 ? "bg-secondary" : "bg-accent";
    },
    getCitySlug(city) {
      return this.slugMap[city] || null;
    },
  },
};
</script>

<style scoped>
#name {
  font-size: clamp(1.5em, 5vw, 3em);
  font-family: "ManropeLight", Arial, Helvetica, sans-serif;
}

.font {
  font-size: 1em;
  font-family: "ManropeLight", Arial, Helvetica, sans-serif;
}

#title {
  border-radius: 15px 0px 0px 15px;
}

#intro-card {
  border-radius: 0px 15px 15px 0px;
}

#tier-card {
  border-radius: 15px 0px 0px 15px;
}

#services-card {
  border-radius: 0px 15px 15px 0px;
}

#cta-card {
  border-radius: 0px 15px 15px 0px;
}

.city-list {
  line-height: 1.8;
}

.city-link {
  color: inherit;
  text-decoration: underline;
  text-underline-offset: 2px;
}

.city-link:hover {
  opacity: 0.8;
}

.service-list {
  padding-left: 1.2em;
  line-height: 2;
}
</style>
